import * as React from 'react';
import { ExtendsFieldId } from '../sic-lib/types/generics';
import { hasDistinctFieldId } from '../sic-lib/utils/functionalFilters';
import { mapToListOfFieldIds } from '../sic-lib/utils/functionalMappers';

/**
 * useFindDifference
 *
 * @description
 * returns typed object where compared fieldIds are not found in both arrays.
 *
 * @param typeArray Array of type expected as return value
 * @param referenceArray Array to comapare against
 */
export default function useFindDifference<T extends ExtendsFieldId, T1 extends ExtendsFieldId>(
    typeArray: T[],
    referenceArray: T1[],
): T[] {
    const [uniqueList, setUniqueList] = React.useState<T[]>([]);

    React.useEffect(() => {
        const referenceIds = referenceArray.map(mapToListOfFieldIds);
        const uniqueFields = typeArray.filter(hasDistinctFieldId(referenceIds));

        setUniqueList(uniqueFields);
    }, [typeArray, referenceArray]);

    return uniqueList;
}
